import React from 'react';
import { Typography, Tooltip, IconButton } from '@mui/material';
import { trakrefFontFamily } from '../../../utils';
import { toolTipBlue, Grey1 } from '../../../color_utils';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import PropTypes from 'prop-types';

const PageTitleWithToolTip = ({
    pageTitle,
    toolTipText,
    toolTipNode,
    fontSize,
    color,
    tooltipMarginLeft,
    sx,
    placement
}) => (
    <>
        <Typography
            variant="h5"
            sx={{ ...sx }}
            style={{ color, fontSize }}
        >
            {pageTitle}
            {(toolTipText || toolTipNode) && (
                <Tooltip
                    arrow
                    title={toolTipNode ? toolTipNode : <div
                        dangerouslySetInnerHTML={{
                            __html: toolTipText,
                        }}
                    />}
                    placement= {placement}
                    componentsProps={{
                        tooltip: {
                            sx: {
                                bgcolor: toolTipBlue,
                                fontSize: "12px",
                                fontFamily: trakrefFontFamily,
                                '& .MuiTooltip-arrow': {
                                    color: toolTipBlue,
                                },
                            },
                        },
                    }}
                >
                    <IconButton sx={{
                        display: { xs: 'none', lg: 'inline-flex' },
                        ":focus": {
                            outline: "none",
                        },
                        marginLeft: tooltipMarginLeft
                    }}>
                        <InfoOutlinedIcon fontSize='small' />
                    </IconButton>
                </Tooltip>
            )}
        </Typography>
    </>
);

PageTitleWithToolTip.propTypes = {
    pageTitle: PropTypes.string.isRequired,
    toolTipText: PropTypes.string,
    fontSize: PropTypes.string,
    toolTipNode: PropTypes.node,
    color: PropTypes.string,
    tooltipMarginLeft: PropTypes.string,
    sx: PropTypes.object,
    placement: PropTypes.string,
};

PageTitleWithToolTip.defaultProps = {
    toolTipText: "",
    fontSize: "24px",
    color: Grey1,
    tooltipMarginLeft: "1%",
    sx: {},
    placement: 'right'
};

export default PageTitleWithToolTip;